"use client";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectUserProfile, selectUserStatus, selectUserFilialeProfile, selectIsFilialeProfileLoaded } from "@store/selectors/user.selectors";
import { Skeleton } from "@/components/ui/skeleton";
import clsx from "clsx";
import { selectBrandName } from "@/lib/store/features/styleSchemaSlice";

export default function Greating() {
    const { t } = useTranslation();
    const profile = useSelector(selectUserProfile);
    const filialeProfile = useSelector(selectUserFilialeProfile);
    const isFilialeLoaded = useSelector(selectIsFilialeProfileLoaded);
    const status = useSelector(selectUserStatus);
    const isLoading = status === "loading";
    const hasProfileData = profile?.firstname && profile?.lastname && profile?.salutation;
    const hasFilialeData = filialeProfile?.title_filiale || filialeProfile?.c_o;
    const brand = useSelector(selectBrandName);

    // Bestimme, ob wir eine Filiale-Begrüßung oder normale User-Begrüßung zeigen
    const showFilialeGreeting = isFilialeLoaded && hasFilialeData;

    return (
        <div className={clsx("text-xl font-exosoft font-bold", {
            "border-r-white border-r-[3px] pr-4": !isLoading && (hasProfileData || showFilialeGreeting) && brand !== "styleboxx" && brand !== "hairexpress" && brand !== "cosmo",
            "border-[--global-font-color] border-r-[3px] pr-4": !isLoading && (hasProfileData || showFilialeGreeting) && brand === "styleboxx" || brand === "hairexpress" || brand === "cosmo",
            "text-white": brand !== "styleboxx" && brand !== "hairexpress" && brand !== "cosmo",
            })}>
            {isLoading ? (
                <div className="flex gap-2 items-center">
                    <Skeleton className="h-8 w-40 bg-gray-300/50" />
                    <Skeleton className="h-8 w-48 bg-gray-300/50" />
                </div>
            ) : showFilialeGreeting ? (
                <span className="gap-2">
                    {t("filiale.dashboard.welcome", { filialeName: filialeProfile.c_o || filialeProfile.title_filiale })}
                </span>
            ) : hasProfileData ? (
                <span className="gap-2">{t("app.greating")}, {profile.salutation} {profile.firstname} {profile.lastname}</span>
            ) : (
                <div className="flex gap-2 items-center">
                    <Skeleton className="h-8 w-40 bg-gray-300/50" />
                    <Skeleton className="h-8 w-48 bg-gray-300/50" />
                </div>
            )}
        </div>
    );
}
